import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Timeline } from "./ui/Timeline";

const DetalleVacanteScreen = () => {
  const { state } = useLocation();
  const { idSolicitud: paramId } = useParams();
  const navigate = useNavigate();

  const solId = Number(paramId || state?.idSolicitud);

  const volver = () => {
    return navigate(-1, { state });
  };

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="card shadow-sm border-0 rounded-3">
          <div className="card-header bgArcopime text-white rounded-top-3">
            <span className="h6 my-0 fw-bold">Historial de Solicitud</span>
          </div>
          <div className="card-body p-4">
            {solId ? (
              <Timeline id={solId} volver={volver} endpoint="solicitudlogtimeline" />
            ) : (
              <div className="text-center text-muted p-4">
                No se especificó un ID de solicitud válido.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetalleVacanteScreen;
